

<template>
  <p class="mt-5">
    <span v-if="session.is_cancelled" :href="goToUrl(session)"
          class="inline-flex items-center px-3 py-0.5
rounded-full text-sm font-medium bg-yellow-100 text-yellow-800"
          target="target-zoom">
      <svg class="-ml-1 mr-1.5 h-2 w-2 text-yellow-400"
           fill="currentColor" viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="3"/>
      </svg>
      CANCELLED
    </span>
    <template v-else-if="(!session.is_cancelled) && (session.hasVirtual || session.hasPhysical)">
      <a
          class="inline-flex items-center px-2.5 py-1.5 border border-gray-300
                      shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none
                      focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          v-if="session.hasVirtual && session.authUrl"
          :href="goToUrl(session)"
          target="target-zoom">
        <svg class="-ml-1 mr-1.5 h-2 w-2 text-orange-400" fill="currentColor" viewBox="0 0 8 8">
          <circle cx="4" cy="4" r="3"/>
        </svg>
        Enter here: [{{ session.urlType }}]
      </a>
      <a
          v-if="session.hasVirtual && !session.authUrl"
          :href="hiddenUrl()"

          class="text-white line-flex items-center px-3 py-2 border
                              border-transparent text-sm leading-4 font-medium rounded-md shadow-sm
                              text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none
                              focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        <template v-if="isMember">
          Get your ticket
        </template>
        <template v-else-if="isUser">
          Join the event space
        </template>
        <template v-else>
          Please log in
        </template>
      </a>
    </template>
  </p>
</template>

<script>

export default {
  name: "SessionLiveData",
  props:
      {
        session: {
          type: Object,
          required: true
        },
        isMember: {
          type: Boolean,
          required: true
        },
        isUser: {
          type: Boolean,
          required: true
        },
        hasTicket: {
          type: Boolean,
          required: true
        }
      }
}

</script>

<style scoped>

.delimiter {
  color: #ccc;
}

.pr {
  color: #666;
}

span.hide-last-delimiter:last-child span.delimiter {
  display: none;
}

.session-wrapping {
  background-color: rgba(0, 0, 0, 0.01);
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.session-wrapping a {
  color: rgb(79, 70, 229);
}

.session-wrapping a.text-white {
  color: #FFF;
}

</style>
